
// 스케줄 > 리스트 > 연속이 아닌 날짜일 경우 데이터 변환해서 return
import dayjs from "dayjs";

export function convertToCon(annualStHalfCd) {
    if (annualStHalfCd) {
        if (annualStHalfCd === 'A') {
            // 오전반차
            return '오전반차'
        } else {
            // 오후반차
            return '오후반차'
        }
    } else {
        // 종일
        return '종일'
    }
}

export function formatDate(value, format) {
    return dayjs(value).format(format);
}

export function dayOfWeek(value) {
    return ['일', '월', '화', '수', '목', '금', '토'][dayjs(value).day()];
}